import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import TitleBanner from './TitleBanner';

function Properties() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    return (
        <>
            <Helmet>
                <title>Properties | Livability Care</title>
            </Helmet>
            <div className="min-h-screen">
                <TitleBanner image="/Website_Title_Images/Transition_and_Respite.svg" title="Disability Housing Vacancies" subheading="Check out our vacancies!" />
            
               
            </div>
        </>
    );
}

export default Properties;